import { BRAND_FULL_NAME, MAIN_SITE_URL } from '@/mocks/categories';
import { seoIntroContent } from '@/mocks/seoContent';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20and%20lifestyle%20product%20display%20with%20carefully%20styled%20clothing%20accessories%20and%20textiles%20artfully%20arranged%20on%20warm%20wooden%20surface%2C%20soft%20diffused%20natural%20window%20light%2C%20minimalist%20boutique%20aesthetic%20with%20cream%20beige%20sage%20green%20and%20warm%20terracotta%20tones%2C%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%2C%20organic%20cotton%20linen%20and%20leather%20textures%2C%20sophisticated%20calm%20atmosphere%20with%20gentle%20shadows%2C%20clean%20organized%20composition&width=1600&height=900&seq=hero-bg-vigorbuy-product-v3&orientation=landscape&nocache=true"
          alt="Vigorbuy Spreadsheet Guide - Premium Lifestyle Collection"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          {seoIntroContent.title}
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-3 max-w-2xl mx-auto leading-relaxed">
          {seoIntroContent.subtitle}
        </p>
        <p className="text-sm md:text-base text-white/75 mb-8 max-w-xl mx-auto leading-relaxed">
          {seoIntroContent.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            Explore Vigorbuy Spreadsheet
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-base font-semibold hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}